import script from "./TcTag.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./TcTag.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcTag.vue?vue&type=script&lang=ts&setup=true"

import "./TcTag.vue.scss?vue&type=style&index=0&id=1bc5552b&lang=scss&scoped=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcTag.vue?vue&type=style&index=0&id=1bc5552b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc5552b"]])

export default __exports__